/**
 * #11 溯源 API client (公開 endpoint,不必 JWT)
 */
import { api } from "./client";

export interface TraceabilityLocation {
  country: string;
  country_zh: string;
  state: string;
  state_zh: string;
  district: string;
  district_zh: string;
  gps: { lat: number; lng: number };
}

export interface TraceabilityBuilding {
  floors: number;
  area_sqft: number;
  founded_year: number;
  harvesting_years: number;
  description_zh: string;
}

export interface TraceabilityCertification {
  authority: string;
  authority_full: string;
  authority_zh: string;
  reviewer_zh: string;
  date: string;
}

export interface TraceabilityData {
  doc_id?: string;
  batch_range: { from: number; to: number };
  house_id: string;
  location: TraceabilityLocation;
  building: TraceabilityBuilding;
  certification: TraceabilityCertification;
  images: { hero: string; gallery: string[] };
  captions_zh: string[];
  narrative_zh: string[];
  headline_zh: string;
  headline_en: string;
  source_url?: string;
}

export interface TraceabilityLookupResponse {
  found: boolean;
  batch?: number;
  data?: TraceabilityData;
  message?: string;
  error?: string;
}

export async function lookupBatch(batch: string | number): Promise<TraceabilityLookupResponse> {
  const { data } = await api.get("/api/traceability/lookup", { params: { batch } });
  return data;
}
